import { useCallback } from 'react';

import { isDefined } from 'utils/tsHelpers';
import { insertInArray } from 'utils/helpers';
import { useRequirementConditionsState } from '../requirement/useRequirementConditionsState';
import { createBlankCondition } from '../../utils';
import { useRequirementDataTypeState } from '../requirement/useRequirementDataTypeState';
import { useCurrentConditionIndex } from './useCurrentConditionIndex';
import { useQueryStateContext } from '../../contexts';

export const useAddCondition = () => {
  const { requirementDataType } = useRequirementDataTypeState();
  const { setConditions } = useRequirementConditionsState();
  const { setToLatestId } = useQueryStateContext();
  const index = useCurrentConditionIndex();

  return useCallback(() => {
    if (isDefined(requirementDataType)) {
      const newCondition = createBlankCondition(requirementDataType);
      setToLatestId(newCondition.id);
      setConditions((conditions) => {
        if (!isDefined(index)) {
          return [newCondition, ...conditions];
        }
        return insertInArray([...conditions], index + 1, newCondition);
      });
    }
  }, [setConditions, requirementDataType, index]);
};
